export default __webpack_public_path__ + "static/media/ATier.6c1cc17e.png";